export default __webpack_public_path__ + "static/media/ic_plugin.ef2bbc02c8e87dde717b06790f6d3232.svg";